import { createStore } from 'vuex'

export default createStore({
  state: {
    // 用户信息
    userInfo: {
      username: '易信网络',
      // phone: '12345678901'
    }
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
